<!--
구매요청 페이지 — 구매정보 수정 레이어 (TASK-161 §0-8 · §3-3 · E5)
------------------------------------
 - 실제결제금액 텍스트 클릭 → 모달
   (사이클 12 §3-2: prop trigger-button = 「수정」 버튼 트리거 — 구매요청 완료 카드 헤더 우측 끝. 금액은 카드 금액 블록이 텍스트로 표시)
 - 오더번호 input 없음 (미결 1 보류 — 수정 불가)
   사이클 13 #5: 레이어 상단 = 해외오더번호 텍스트 + 복사 (prop buy-order-code) · 소속 상품 카드 (공용 app-buy-order-prod-cards readonly)
                 소속 상품 = 첫 open 시 1회 GET /admin/buy-requests/store-order-preview?order_id= (StoreOrderPreviewLogic 오더 기준 조회 분기 — 읽기 전용)
   사이클 16 #27: 상단 = 공용 컨텍스트 헤더 app-buy-order-ctx (오더번호 + 복사 · 트래킹 칩 (소속 상품) · 실제결제금액 큰 글자) · 소속 상품 = 간략 행
 - 「저장」                        → PATCH  /admin/buy-requests/orders/{orderId}         (payment_price [+ cod_payment · req_memo])
   결정 3 (a): 활성 건 없음 = 체크 활성 (기본 OFF) + 비고 입력 → 요청 건 생성 / 활성 건 (취소 제외 전 상태 — 사이클 14 #12) = 비고 수정
   결정 49 c: 실제결제금액 = 요청 상태면 대금상환금액 동기 · 창고지급완료 이상은 수정 허용 + 동기 없음 (대금상환 금액 고정)
 - 「구매정보 삭제」               → DELETE /admin/buy-requests/orders/{orderId}
 - 「대금상환 취소」 (요청 상태만) → PATCH  /admin/buy-requests/cod-payments/{codPaymentId}/cancel (cancel_reason 필수)
 - 대금상환 체크박스 = 활성 건 있으면 disabled (해제 불가) / 없으면 체크 가능
 - 성공 후 페이지 새로고침
-->
<template>
    <div class="bo-edit-layer">
        <!-- 트리거 — 「수정」 버튼 (trigger-button) / 금액 텍스트 링크 (기본) -->
        <button v-if="triggerButton" type="button" class="uk-button uk-button-default uk-button-small bo-edit-trigger bo-edit-button"
                @click="open" title="구매정보 수정 (실제결제금액 · 대금상환 · 삭제)">수정</button>
        <a v-else class="uk-link-reset bo-edit-trigger" href="javascript:void(0)" @click="open" title="구매정보 수정">
            <span v-if="hasPaymentPrice">{{ paymentPriceText }}</span>
            <span v-else class="uk-text-muted">미입력</span>
            <i class="material-icons">edit</i>
        </a>

        <!-- 모달 -->
        <div ref="modal" uk-modal esc-close="false" bg-close="false">
            <div class="uk-modal-dialog uk-modal-body uk-text-left uk-width-xxlarge">
                <button class="uk-modal-close-default" type="button" uk-close></button>
                <h3 class="uk-modal-title">구매정보 수정</h3>

                <!-- 해외오더번호 (읽기 전용 + 복사) · 소속 상품 (사이클 13 #5 — 열 때 1회 조회, 공용 app-buy-order-prod-cards readonly)
                     사이클 16 #27: 컨텍스트 헤더 = 공용 app-buy-order-ctx (오더번호 크게 + 복사 · 트래킹 칩 = 소속 상품 트래킹 · 실제결제금액 큰 글자) -->
                <app-buy-order-ctx class="bo-edit-order" :code="buyOrderCode || ''" :trackings="prodTrackings" :items="ctxItems"></app-buy-order-ctx>
                <div class="uk-margin bo-edit-prods">
                    <label class="uk-form-label">
                        소속 상품 <span v-if="prods !== null">{{ prods.length }}건</span>
                    </label>
                    <div v-if="prodsLoading" class="uk-text-muted bo-edit-prods-loading">
                        <div uk-spinner></div> 소속 상품 확인 중…
                    </div>
                    <div v-else-if="prods !== null" class="bo-edit-prods-wrap">
                        <app-buy-order-prod-cards :prods="prods" readonly></app-buy-order-prod-cards>
                    </div>
                </div>
                <hr/>

                <div class="uk-margin">
                    <label class="uk-form-label">실제결제금액 <span v-if="currency">({{ currency }})</span></label>
                    <div class="uk-form-controls">
                        <input class="uk-input" type="text" v-model.trim="inputPaymentPrice" @keyup.enter="save"
                               placeholder="실제결제금액"/>
                    </div>
                </div>

                <div class="uk-margin">
                    <label>
                        <!-- 결정 3 (a) — 활성 건 없음 = 체크 가능 (요청 건 생성) / 활성 건 있음 = 체크 고정 -->
                        <input v-if="hasActiveCod" class="uk-checkbox bo-cod-check" type="checkbox" checked disabled/>
                        <input v-else class="uk-checkbox bo-cod-check" type="checkbox" v-model="inputCodPayment"/>
                        대금상환
                        <span v-if="hasActiveCod" class="uk-text-muted">({{ codStateText }} — 체크 해제 불가, 「대금상환 취소」 로 처리)</span>
                        <span v-else class="uk-text-muted">(체크 후 저장하면 대금상환 요청이 등록되고 창고문의 글이 작성됩니다)</span>
                    </label>
                </div>

                <!-- 대금상환비고 — 신규 등록 시 입력 / 활성 건 (취소 제외 전 상태) 은 수정 -->
                <div class="uk-margin" v-if="memoEditable">
                    <label class="uk-form-label">대금상환비고</label>
                    <div class="uk-form-controls">
                        <textarea class="uk-textarea bo-req-memo" rows="3" v-model="inputReqMemo" placeholder="대금상환비고 (선택)"></textarea>
                    </div>
                </div>
                <div class="uk-margin" v-else-if="hasActiveCod && reqMemo">
                    <div class="uk-text-muted">대금상환비고</div>
                    <div class="bo-memo">{{ reqMemo }}</div>
                </div>

                <div class="uk-flex uk-flex-between uk-margin-top">
                    <button class="uk-button uk-button-danger" type="button" :disabled="busy" @click="remove">구매정보 삭제</button>
                    <div>
                        <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                        <button class="uk-button uk-button-primary" type="button" :disabled="busy" @click="save">저장</button>
                    </div>
                </div>

                <!-- 대금상환 취소 (요청 상태만) -->
                <div v-if="cancelable" class="uk-margin-top bo-cancel">
                    <hr/>
                    <button class="uk-button uk-button-default" type="button" v-if="! cancelOpened" @click="cancelOpened = true">
                        대금상환 취소
                    </button>
                    <div v-if="cancelOpened">
                        <label class="uk-form-label">대금상환 취소사유 (필수)</label>
                        <textarea class="uk-textarea" rows="3" v-model="inputCancelReason" placeholder="취소사유를 입력하세요"></textarea>
                        <div class="uk-text-right uk-margin-small-top">
                            <button class="uk-button uk-button-default" type="button" @click="cancelOpened = false">접기</button>
                            <button class="uk-button uk-button-danger" type="button" :disabled="busy || ! hasCancelReason" @click="cancelCod">
                                대금상환 취소 확인
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // 대금상환 상태 (App\Code\CodPayment\State — 사이클 14 결정 49 d 재번호: 0 · 10 · 20 · 30 · 90, 라벨 결정 29·30 + 정산확정)
    const COD_STATE_TEXT = {0: '요청', 10: '창고지급완료', 20: '정산확정', 30: '송금완료', 90: '취소'};
    const COD_STATE_REQ = 0;
    const COD_STATE_CANCEL = 90;

    export default {
        props: {
            // csrf-token
            csrfToken: String,

            // 해외오더(구매정보)ID
            orderId: Number,

            // 실제결제금액
            paymentPrice: {
                type: [String, Number],
                default: '',
            },

            // 통화
            currency: {
                type: String,
                default: '',
            },

            // 활성 대금상환ID (없으면 공란)
            codPaymentId: {
                type: [String, Number],
                default: '',
            },

            // 활성 대금상환 상태
            codState: {
                type: [String, Number],
                default: '',
            },

            // 대금상환비고 (표시만)
            reqMemo: {
                type: String,
                default: '',
            },

            // 트리거 = 「수정」 버튼 (사이클 12 §3-2 — 미지정 = 금액 텍스트 링크)
            triggerButton: {
                type: Boolean,
                default: false,
            },

            // 해외오더번호 (표시 + 복사 — 수정 불가, 사이클 13 #5)
            buyOrderCode: {
                type: String,
                default: '',
            },
        },
        data: function () {
            return {
                inputPaymentPrice: this.normalize(this.paymentPrice),
                inputCodPayment: false,
                inputReqMemo: '',
                inputCancelReason: '',
                cancelOpened: false,
                busy: false,

                // 소속 상품 (null = 미조회 — 레이어 첫 open 시 1회 조회)
                prods: null,
                prodsLoading: false,
            };
        },
        computed: {
            hasPaymentPrice() {
                return this.normalize(this.paymentPrice) !== '';
            },

            // 표시용 금액 (JPY 소수점 없음)
            paymentPriceText() {
                let digits = this.currency === 'JPY' ? 0 : 2;
                let num = parseFloat(this.normalize(this.paymentPrice));
                if (isNaN(num)) {
                    return this.normalize(this.paymentPrice);
                }
                return (this.currency ? this.currency + ' ' : '') + this.$formatNumber(num, digits);
            },

            // 컨텍스트 헤더 트래킹 칩 = 소속 상품의 트래킹번호 (중복 · 빈 값 제외 — 사이클 16 #27). 조회 전 = null (줄 숨김)
            prodTrackings() {
                if (this.prods === null) {
                    return null;
                }
                return _.uniq(_.filter(_.map(this.prods, (p) => this.normalize(p.tracking_no)), (no) => no !== ''));
            },

            // 컨텍스트 헤더 키-값 = 실제결제금액 큰 글자 (사이클 16 #27)
            ctxItems() {
                return [
                    {k: '실제결제금액', v: this.hasPaymentPrice ? this.paymentPriceText : '미입력', big: this.hasPaymentPrice},
                ];
            },

            codStateNumber() {
                let s = this.normalize(this.codState);
                return s === '' ? null : parseInt(s, 10);
            },

            hasActiveCod() {
                return this.normalize(this.codPaymentId) !== ''
                    && this.codStateNumber !== null
                    && this.codStateNumber !== COD_STATE_CANCEL;
            },

            codStateText() {
                return COD_STATE_TEXT[this.codStateNumber] || '';
            },

            // 취소 펼침 노출 = 활성 요청 상태만
            cancelable() {
                return this.hasActiveCod && this.codStateNumber === COD_STATE_REQ;
            },

            hasCancelReason() {
                return this.inputCancelReason.trim() !== '';
            },

            // 비고 입력·수정 가능 = (활성 건 없음 + 체크 ON) 또는 활성 건 전부 (사이클 14 #12 — 취소 제외 전 상태, 서버 UpdateLogic 과 같은 규칙)
            memoEditable() {
                if (! this.hasActiveCod) {
                    return this.inputCodPayment;
                }
                return true;
            },
        },
        methods: {
            normalize(val) {
                return (val === null || val === undefined) ? '' : String(val).trim();
            },

            open() {
                this.inputPaymentPrice = this.normalize(this.paymentPrice);
                this.inputCodPayment = false;
                // 활성 건 비고만 프리필 (취소 건 비고는 새 등록에 끌고 오지 않음)
                this.inputReqMemo = this.hasActiveCod ? this.normalize(this.reqMemo) : '';
                this.inputCancelReason = '';
                this.cancelOpened = false;
                UIkit.modal(this.$refs.modal).show();
                this.loadProds();
            },

            // 소속 상품 조회 (읽기 전용 — GET store-order-preview?order_id=, 사이클 13 #5). 첫 open 1회만.
            loadProds() {
                if (this.prods !== null || this.prodsLoading || ! this.orderId) {
                    return;
                }
                this.prodsLoading = true;
                $.app.ajax.module.default({
                    type: 'get',
                    url: '/admin/buy-requests/store-order-preview',
                    dataType: 'json',
                    data: {
                        order_id: this.orderId,
                    },
                    success: (response) => {
                        this.prods = (response && Array.isArray(response.prods)) ? response.prods : [];
                    },
                    complete: () => {
                        this.prodsLoading = false;
                    },
                });
            },

            /**
             * 공통 ajax (실패 = 서버 메세지 alert — $.app.ajax.module.default 기본 처리)
             * @return Promise
             */
            request(type, url, data) {
                this.busy = true;
                return new Promise((resolve, reject) => {
                    $.app.ajax.module.default({
                        type: type,
                        url: url,
                        dataType: 'json',
                        data: Object.assign({_token: this.csrfToken}, data || {}),
                        success: (response) => {
                            resolve(response);
                        },
                        complete: () => {
                            this.busy = false;
                        },
                    });
                });
            },

            done(response) {
                if (response && response.msg) {
                    alert(response.msg);
                }
                location.reload();
            },

            // 저장 — 1 요청 1 트랜잭션 (금액 → 대금상환 생성 → 비고, 결정 3 지침 3 ⓐ)
            save() {
                if (this.busy) {
                    return;
                }
                let data = {
                    payment_price: this.inputPaymentPrice,
                };
                if (! this.hasActiveCod && this.inputCodPayment) {
                    // 재등록·사후 등록
                    data.cod_payment = 'yes';
                    data.req_memo = this.inputReqMemo;
                } else if (this.memoEditable) {
                    // 활성 건 비고 수정만
                    data.req_memo = this.inputReqMemo;
                }
                this.request('patch', '/admin/buy-requests/orders/' + this.orderId, data).then(this.done);
            },

            // 구매정보 삭제
            remove() {
                if (this.busy) {
                    return;
                }
                if (! confirm('구매정보를 삭제합니다. 정말 실행합니까?')) {
                    return;
                }
                this.request('delete', '/admin/buy-requests/orders/' + this.orderId, {}).then(this.done);
            },

            // 대금상환 취소 (사유 필수 — 공란 submit 차단)
            cancelCod() {
                if (this.busy) {
                    return;
                }
                if (! this.hasCancelReason) {
                    alert('대금상환 취소사유를 입력해 주세요.');
                    return;
                }
                if (! confirm('대금상환을 취소합니다. 정말 실행합니까?')) {
                    return;
                }
                this.request('patch', '/admin/buy-requests/cod-payments/' + this.normalize(this.codPaymentId) + '/cancel', {
                    cancel_reason: this.inputCancelReason.trim(),
                }).then(this.done);
            },
        },
    }
</script>

<style lang="scss" scoped>
    .bo-edit-trigger {
        display: inline-flex;
        align-items: center;
        cursor: pointer;

        .material-icons {
            font-size: 1rem;
            margin-left: 2px;
            color: #999;
        }

        &:hover .material-icons {
            color: dodgerblue;
        }
    }
    .bo-memo {
        white-space: pre-wrap;
    }

    // (구 해외오더번호 텍스트 .bo-edit-code · 소속 상품 높이 제한 .bo-edit-prods-wrap 40vh = 사이클 16 #27 공용 컨텍스트 헤더 · 공용 목록 안 스크롤로 대체)
</style>
